import { render, staticRenderFns } from "./ReminderForm.vue?vue&type=template&id=3b296cca&scoped=true"
import script from "./ReminderForm.vue?vue&type=script&lang=ts"
export * from "./ReminderForm.vue?vue&type=script&lang=ts"
import style0 from "./ReminderForm.vue?vue&type=style&index=0&id=3b296cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b296cca",
  null
  
)

export default component.exports